__webpack_public_path__ = __CLIENT_HOLOCRON_MODULE_MAP__.modules['axp-one-maps'].baseUrl;
import Maps from './Maps';
export default Maps;
;
if (!global.BROWSER) {
  Maps.appConfig = Object.assign({}, Maps.appConfig, {
    appCompatibility: "^5.0.0"
  });
}
;
if (!global.BROWSER) {
  Maps.appConfig = Object.assign({}, Maps.appConfig, {
    requiredExternals: {
      '@americanexpress/react-ddl': '^0.3.3',
      'axp-product-ducks': '^0.4.16',
      'iguazu': '^3.1.0',
      'iguazu-graphql': '^1.3.0',
      'iguazu-holocron': '^1.8.2',
      'iguazu-rest': '^1.11.1',
      'iguazu-rpc': '^1.6.1',
      'reactlytics': '^1.2.5'
    }
  });
}